import {getCookie, setCookie} from '../../globals/cookies'

function hideCommentSectionIfEmpty() {
  if ($("[data-comment-id]").length < 1) {
    // Hiding the comment section
    $("[data-comment-title]").hide(0);
    $("[data-comment-wrapper]").hide(0);
  }
}

function wireUpReplyCancel() {
  $("[data-comment-reply-form-cancel]").off('click').on('click', function(e) {
    const articleElement = $(this).closest("[data-blog-article-id]");
    const form = articleElement.find("[data-comment-reply-form]").first();
    const hiddenFormContainer = articleElement.find("[data-comment-reply-container]").first();
    form.detach().appendTo(hiddenFormContainer);
    initBlogCommentListing();
  });
}

function wireUpReplyForm() {
  $("[data-comment-leave-comment]").off('click').on('click', function(e) {
    e.preventDefault();
    const articleElement = $(this).closest("[data-blog-article-id]");
    const commentElement = $(this).closest("[data-comment-id]");
    const form = articleElement.find("[data-comment-reply-form]").first();
    const formHolder = commentElement.find("[data-comment-form-holder]").first();
    form.detach().appendTo(formHolder);
    const commentId = commentElement.attr("data-comment-id");
    form.find("[name='CommentParentId'").first().val(commentId);
    const authorName = commentElement.find("[data-comment-author-name]").first().text();
    commentElement.find("[data-comment-author-name-title]").first().text(authorName);
    initBlogCommentListing();
  });
}

function wireUpCommentLoadMore() {
  $("[data-comment-load-more]").off('click').on('click', function(e) {
    e.preventDefault();
    $(this).off();
    $(this).closest("[data-comment-load-more-container]").hide("slow");
    const articleId = $(this).closest("[data-blog-article-id]").attr("data-blog-article-id");
    const configId = $(this).closest("[data-blog-article-config-id]").attr("data-blog-article-config-id");
    const pageNumberElement = $(this).closest("[data-comment-page]");
    const pageNumber = parseInt(pageNumberElement.attr("data-comment-page"));
    const commentContainer = $(this).closest("[data-comment-container]");
    const requestData = {
      articleId: articleId,
      configId: configId,
      page: pageNumber + 1
    }

    $.get("/api/sitecore/Blog/BlogCommentListing", requestData)
      .done(function(data) {
      commentContainer.append(data);
      pageNumberElement.attr("data-comment-page", pageNumber + 1);
      initBlogCommentListing();
    })
    .fail(function() {
      console.error("Unable to get blog comments with the data: " + JSON.stringify(requestData));
    });
  });
}

function wireUpReplyListing() {
  // hooking up event to display/hide comment replies
  $("[data-comment-view-replies]").off('click').on('click', function(e) {
    e.preventDefault();

    // Disable button until response
    $(this).off('click');
    const parentComment = $(this).closest("[data-comment-id]");
    const replyDestination = parentComment.find("[data-reply-holder]").first();

    if (!$(this).hasClass("active")) {
      // expanding the replies
      $(this).addClass("active");
      const parentCommentId = parentComment.attr('data-comment-id');
      const requestData = {
        commentId: parentCommentId
      }
      $.get("/api/sitecore/Blog/BlogCommentReplyListing", requestData)
        .done(function(data) {
          // appending replies to comment
          replyDestination.append(data);
        })
        .fail(function() {
          console.error("Unable to get blog replies with the data: " + JSON.stringify(requestData));
        })
        .always(function() {
          initBlogCommentListing();
        });
    } else {
    // collapsing the replies
    $(this).removeClass("active")
      replyDestination.empty();
      initBlogCommentListing();
    }
  });
}

function wireUpForm() {
  // setting up cookie for saving info
  const saveInfoCookieName = "pods-comment-info";
  const encodedCookie = getCookie(saveInfoCookieName);
  var formFlag;
  var emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
  if (encodedCookie) {
    try {
      const userInfo = JSON.parse(window.atob(encodedCookie));
      $("[data-blog-comment-form] [name=Name]").val(userInfo.name);
      $("[data-blog-comment-form] [name=Email]").val(userInfo.email);
      $("[data-blog-comment-form] [name=saveinfo]").attr('checked', "checked");
    } catch(error) {
      console.error(error);
    }
  }

  $("[data-blog-comment-form] [name=Name], [data-blog-comment-form] [name=Content]").off("keyup").on("keyup", function(){
    var txtLength = 50;
    var errElemA = $(this).parent().prev().find(".comment-error");
    var errElemB = $(this).parent().prev().find(".comment-length-error");
    if($.trim($(this).val()) == ""){
      errElemA.addClass("in-trouble");
      errElemB.removeClass("in-trouble");
    } else if($.trim($(this).val()) != "" && $.trim($(this).val()).length < txtLength){
      console.log('Condition 1');
      if(errElemA.hasClass("in-trouble")){
        errElemA.removeClass("in-trouble");
        formFlag = 0;
      }
      if(errElemB.hasClass("in-trouble")){
        errElemB.removeClass("in-trouble");
        formFlag = 0;
      }
    }else if($.trim($(this).val()).length > txtLength && $(this).attr("name") != "Content"){
      console.log('Condition 2');
      errElemB.addClass("in-trouble");
      errElemA.removeClass("in-trouble");
      formFlag = 1;
    }else{
      console.log('Condition 3');
      errElemB.addClass("in-trouble");
      errElemA.removeClass("in-trouble");
      formFlag = 0;
    }
    $(".validationFlag").val(formFlag);
  });

  $("[data-blog-comment-form] [Name=Email]").off("keyup").on("keyup", function(){
    var errElemA = $(this).parent().prev().find(".comment-error");
    if(emailPattern.test($(this).val())){
      if(errElemA.hasClass("in-trouble")){
        errElemA.removeClass("in-trouble");
        formFlag = 0;
      }
    }else{
      errElemA.addClass("in-trouble");
      formFlag = 1;
    }
    $(".validationFlag").val(formFlag);
  })

  $("[data-blog-comment-form]").off('submit').on('submit', function(e) {
    e.preventDefault();
    const articleElement = $(this).closest("[data-blog-article-id]");
    const form = $(this);
    const url = form.attr("action");
    const method = form.attr("method");
    const payload = $(this).serialize();
    const name = form.find("[name=Name]").val();
    const email = form.find("[name=Email]").val();
    const saveInfo = form.find("[name=saveinfo]").is(':checked');
    const isReply = form.attr("data-form-role") === "reply";
    const comment = isReply ? form.closest("[data-comment-id]") : null;
    const commentVal = form.find("[name=Content]").val();

    //Validations
    validateFormElement(form, form.find("[name=Content]"), 'nullCheck');
    validateFormElement(form, form.find("[name=Name]"), 'nullCheck');
    validateFormElement(form, form.find("[name=Email]"), 'nullCheck');
    validateFormElement(form, form.find("[name=Email]"), 'emailCheck');

    var formValidationFlag = form.find("[name=validationFlag]").val();

    if(formValidationFlag == 0){
      $("[data-blog-comment-form] input, [data-blog-comment-form] textarea").attr('disabled', true);
      $.ajax({
        url: url,
        type: method,
        data: payload,
        dataType: "html"
      })
      .done(function(response) {
        // resetting forms
        $("[data-blog-comment-form]").trigger('reset');

        // handling saving info if checkbox is checked
        if (saveInfo) {
          $("[data-blog-comment-form] [name=Name]").val(name);
            $("[data-blog-comment-form] [name=Email]").val(email);
            $("[data-blog-comment-form] [name=saveinfo]").attr('checked', "checked");
            const saveInfo = {
              name: name,
              email: email
            };
            setCookie(saveInfoCookieName, window.btoa(JSON.stringify(saveInfo), 10 * 365)); // setting cookie for 10 years
            $("[data-blog-comment-form] input, [data-blog-comment-form] textarea").attr('disabled', false);
          } else {
            // removing cookie
            setCookie(saveInfoCookieName, "", -1);
          }

          // adding success message
          if (isReply) {
            comment.find("[data-comment-submit-preview]").append(response);
          }
          else {
            // Showing the comment section if it was hidden doesn't exist
            if ($("[data-comment-id]").length < 1) {
              $("[data-comment-title]").show();
              $("[data-comment-wrapper]").show();
            }

            // adding the preview message
            articleElement.find("[data-comment-container]").first().append(response);
          }
        })
        .fail(function(error) {
          console.error(error);
          // getting generic error message
          const errorMessage = form.closest("[data-blog-article-id]").find("[data-reply-fail]").html();
          // putting the error message in the right place
          if (isReply) {
            comment.find("[data-comment-submit-preview]").first().append(errorMessage);
          } else {
            form.closest("[data-blog-article-id]").find("[data-comment-container]").first().append(errorMessage);
          }

          // resetting form
          $("[data-blog-comment-form]").trigger('reset');
        })
        .always(function() {
         // putting reply form back
          const replyForm = articleElement.find("[data-comment-reply-form]").first();
          const hiddenFormContainer = articleElement.find("[data-comment-reply-container]").first();
          replyForm.detach().appendTo(hiddenFormContainer);

         // initializing all events
          initBlogCommentListing();

         // enabling form
          $("[data-blog-comment-form] input, [data-blog-comment-form] textarea").attr('disabled', false);
        });
      }
    });
  }

  function initBlogCommentListing() {
    wireUpCommentLoadMore();
    wireUpReplyListing();
    wireUpReplyForm();
    wireUpReplyCancel();
  }

  function validateFormElement(form, elem, validationType){
    var formFlag, formFlagEmail;
    var emailPattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var  txtLength = 50;

    if (validationType == "nullCheck"){
      if ($.trim(elem.val()) == ""){
        elem.parent().prev().find(".comment-error").addClass("in-trouble");
        elem.parent().prev().find(".comment-length-error").removeClass("in-trouble");
        formFlag = 1;
      }
      else if ($.trim(elem.val()).length > txtLength){
        elem.parent().prev().find(".comment-length-error").addClass("in-trouble");
        elem.parent().prev().find(".comment-error").removeClass("in-trouble");
        formFlag = 1;
      } else {
        elem.parent().prev().find(".comment-error").removeClass("in-trouble");
        elem.parent().prev().find(".comment-length-error").removeClass("in-trouble");
        formFlag = 0;
      }
    }

    if($.trim(elem.val()) != "" && validationType == "emailCheck"){
      if(!emailPattern.test($.trim(elem.val()))){
        elem.parent().prev().find(".comment-error").addClass("in-trouble");
        formFlagEmail = 1;
      } else{
        elem.parent().prev().find(".comment-error").removeClass("in-trouble");
        formFlagEmail = 0;
      }
    }

  if(formFlag == 1 || formFlagEmail == 1)
    form.find(".validationFlag").val("1");
}

$(document).ready(function () {
  initBlogCommentListing();
  wireUpForm();
  hideCommentSectionIfEmpty();
});
